import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { getGlobalClasses } from '../../themes';
import UserPicker from '../../components/advancedForm/UserPicker';
import FormComponent from '../../components/FormComponent';
import FormDatePicker from '../../components/form/FormDatePicker';
import { post } from '../../modules/utility';
import AuthUserContainer from '../../containers/AuthUser';
import printJS from 'print-js';
import { CircularProgress } from '@material-ui/core';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
	};
};

class TestDeliveryTickets extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			isSearching: false,
			userId: undefined,
			overrideShiftDate: undefined,
		};
	}

	render() {
		const { classes } = this.props;
		const { isSearching } = this.state;
		return (
			<Paper className={classes.globalMainPaper}>
				<Grid container>
					<Grid item xs={12} md={3}>
						<UserPicker
							{...this.setForm('userId', 'Drivers')}
							selectMultiple={false}
							whoToShow={'driversOnly'}
							//includeHidden={true}
						/>

						<FormDatePicker
							{...this.setForm('overrideShiftDate', 'Shift Date', true)}
							gridProps={{ md: 12 }}
						/>
						<div style={{ marginTop: 10, marginBottom: 10, padding: 10, fontSize: 13 }}>
							Note: If you leave Shift Date blank it will look up the driver's current clocked in
							shift and use that date. If the driver is not clocked in it will produce an error.
						</div>

						<Button
							color="primary"
							variant="contained"
							aria-label="Logout"
							onClick={this.showDeliveryTickets}
							style={{ marginBottom: 10 }}
						>
							Show Delivery Tickets
						</Button>

						<Button
							color="primary"
							variant="contained"
							aria-label="Logout"
							onClick={this.printDeliveryTickets}
						>
							Print Delivery Tickets
						</Button>

						{isSearching && (
							<div className={classes.runningSearch}>
								<CircularProgress />
								<span style={{ paddingLeft: 10, paddingTop: 10 }}>Searching...</span>
							</div>
						)}
					</Grid>
					<Grid item xs={12} md={9}>
						{this.state.iframeUrl && (
							<iframe
								key={this.state.refreshId}
								title="deliveryTickets"
								src={this.state.iframeUrl}
								height="920px"
								width="100%"
								frameBorder="0"
								scrolling="yes"
								allowFullScreen={true}
								style={{ border: '4px solid #ddd' }}
							></iframe>
						)}
					</Grid>
				</Grid>
			</Paper>
		);
	}

	printDeliveryTickets = () => {
		const { showErrors } = this.props;
		const { userId, overrideShiftDate } = this.state;

		this.setState({ isSearching: true });

		post({
			method: 'tmw.getDeliveryTicketsPdf',
			params: {
				userId,
				overrideShiftDate,
			},
			callback: (err, r) => {
				this.setState({ isSearching: false });
				if (err) {
					return showErrors(err);
				}

				if (!r.resource) {
					return showErrors('Missing resource');
				}
				const url = r.resource.url;
				printJS({ printable: url, type: 'pdf' });
			},
		});
	};

	showDeliveryTickets = () => {
		const { showErrors } = this.props;
		const { userId, overrideShiftDate } = this.state;
		if (!userId) {
			console.log('Missing userId');
			return showErrors(['Dude. Pick a driver please']);
		}

		let iframeUrl = `/printable/driverDeliveryTickets/${userId}`;
		if (overrideShiftDate) {
			iframeUrl = `/printable/driverDeliveryTicketsWithOverride/${userId}/${overrideShiftDate}`;
		}

		this.setState({
			refreshId: Math.random(),
			iframeUrl,
		});
	};
}

TestDeliveryTickets.propTypes = {
	classes: PropTypes.object.isRequired,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles)], AuthUserContainer)(TestDeliveryTickets);
